import { render, staticRenderFns } from "./FoodcourtRestaurantsList.vue?vue&type=template&id=e863a434&scoped=true"
import script from "./FoodcourtRestaurantsList.vue?vue&type=script&lang=js"
export * from "./FoodcourtRestaurantsList.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtRestaurantsList.vue?vue&type=style&index=0&id=e863a434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e863a434",
  null
  
)

export default component.exports